$( document ).ready(function() {
  $('.ctm_feature_col_slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1324,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
         
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
         
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows:false,
          dots: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows:false,
          dots: true,
        }
      }
    ]  
  });


  $('.collection_slider').slick({
    slidesToShow: 5,
    infinite: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1324,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
         
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
         
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows:false,
          dots: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows:false,
          dots: true,
        }
      }
    ]  
  });
  $('.ctm_collection_slider').slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
         
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows:false,
          dots: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows:false,
          dots: true,
        }
      }
    ]  
  });


  // ======  Swiper =======

  var swiper = new Swiper(".mySwiper", {
    grabCursor: true,
    freeMode: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      // when window width is >= 640px
      1240: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }

  });

  // ======= Model ====== //
const modal = document.getElementById("myModal");
const btn = document.getElementById("model_opener");
const span = document.getElementsByClassName("close_model")[0];
if (btn) {
  btn.onclick = function() {
    modal.style.display = "block";
  }
}
if (btn) {
  span.onclick = function() {
    modal.style.display = "none";
  }
}
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

// ====================================  Encraving text js ===================================

const engravetext = document.querySelector('.engraving_media .engraving_text');
const engravingMessageText = document.querySelector('.message_engraving');
const metafieldFontSize = (engravetext ? engravetext.dataset.fontSize : 10) + 'px';
document.querySelector('.engraving_inputs input[type="text"]')?.addEventListener('input', function(event) {
  event.preventDefault(); 
  
  var nameInput = this.value.trim();
  if (nameInput === '') {
    document.querySelector('input[type="submit"]').disabled = true; 
    alert('Name cannot be blank');
  } else {
    document.querySelector('input[type="submit"]').disabled = false;
    const engraveInput = this.closest('.engraving_model_container_inner')?.querySelector('input[type="text"]').value;
    engravetext.innerText = engraveInput;
  }
 
});

document.querySelector('input[type="submit"]')?.addEventListener('click', function(evt) {
  let engraving_model_id = this.closest('#engraving_model_id');
  let engravingVal = engraving_model_id.querySelector('input[name="name"]').value.trim();
  if (engravingVal == '') {
      alert('Name cannot be blank');
      document.querySelector('input[type="submit"]').disabled = true;
  } else {
      engraving_model_id.querySelector('.engravingCloseModal').setAttribute("rel", "modal:close")
  }
})

document.querySelector('.engraving_inputs input[type="submit"]')?.addEventListener('click', function(event) {
  event.preventDefault(); 
  const engraveInput = this.closest('.engraving_model_container_inner')?.querySelector('input[type="text"]').value.trim();


  const engravetextStyle = window.getComputedStyle(document.querySelector('.engraving_text'));
  
  const engravingColor = engravetextStyle.getPropertyValue('color');
  const engravingFontFamily = engravetextStyle.getPropertyValue('font-family');
  // const engravingFontSize = engravetextStyle.getPropertyValue('font-size'); 

  if ( engraveInput != '') {
    document.querySelector('#custom-engraving-name').value = engraveInput;
    document.querySelector('#custom-engraving-color').value = engravingColor;
    document.querySelector('#custom-engraving-font-family').value = engravingFontFamily;
    document.querySelector('#custom-engraving-font-size').value = metafieldFontSize;
    engravingMessageText.innerHTML = `Customise name : ${engraveInput}`
    engravingMessageText.style.display ='inline-block'
    console.log(engravingMessageText);
  }

});

document.querySelectorAll('form[action="/cart/add"]')?.forEach(function (currElem) {
    currElem.addEventListener('submit',function (evt) {
      evt.preventDefault();
      
        const engraveInput =  document.querySelector('#custom-engraving-name').value.trim();

        if (engraveInput == '') {
          console.log(' check');
          document.querySelector('#custom-engraving-name').remove();
          document.querySelector('#custom-engraving-color').remove();
          document.querySelector('#custom-engraving-font-family').remove();
          document.querySelector('#custom-engraving-font-size').remove();
        }
    })
})
  
});



//  =================== Currency Converter with App =====================

document.addEventListener('DOMContentLoaded', () =>{

  document.querySelectorAll('.ctm_flag_outer')?.forEach(function(currElem){
    currElem.closest('.disclosure')?.querySelectorAll('.country-selector__list li a')?.forEach(function (elem) {
      elem.addEventListener('click',function(){
        let currentVal = elem.dataset.value;
       
        currentVal == "US" ? document.querySelector('li#USD').click() : '';
        currentVal == "IN" ? document.querySelector('li#INR').click() : '';
        currentVal == "CA" ? document.querySelector('li#CAD').click() : '';
      })
    })
  })

})

document.addEventListener("readystatechange", function() {
  if ("complete" == document.readyState) {
    function onScrollRecomendation() {
      const allCardsFound = document.querySelectorAll('product-recommendations .card-information').length > 0;
      if (allCardsFound) {
        window.removeEventListener("scroll", onScrollRecomendation);
        const currentCurElement = document.querySelector('[data-curr]');
        const currentCur = currentCurElement?.getAttribute('data-curr');
        const matchingCur = Array.from(document.querySelectorAll('.converterTriggers')).find(cur => cur.getAttribute('rel')?.toLowerCase().startsWith(currentCur?.toLowerCase()));
        matchingCur ? matchingCur.click() : null;
      }
    }
    if (document.querySelector('[template="product"]')) window.addEventListener("scroll", onScrollRecomendation);
  }
});


















// document.querySelectorAll('product-recommendations .price__container').forEach((pContainer)=>{
//   pContainer.style.setProperty('display', 'inline-block', 'important');
// })

// phone input field

// $(document).ready(function () {
//   window.onload = function() {
//     setTimeout(()=>{
//       // console.log("CTM script runnig start!");
//       let locals = $(".buckscc-floating-box").clone(true);
//       $(".desktop-localization-wrapper").html(locals);
//       // console.log(locals);
//       // console.log("CTM script runnig ends!");
//     },1540)
//   }
// })

//  Calulate Font Size For Custom text

// function calculateFontSize() {
//   var isMobile = window.innerWidth <= 768; 
//   if (isMobile) {
//     var viewportWidth = window.innerWidth || document.documentElement.clientWidth;;
//     var calculatedFontSize = engravetext.dataset.fontSize - (viewportWidth * 0.01); 
    
//     engravetext.style.fontSize = calculatedFontSize + "px";
//     // console.log( engravetext.style.fontSize);
//   }
// }

// calculateFontSize();
// window.addEventListener('resize', calculateFontSize);